import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";
import { SETTLEMENT_STYLES } from "../../../style/styles";

export default function SettlementPaymentsSingleSelectDropdown({
  fieldName,
  fieldValue,
  onChange,
  data = [],
  placeholder = "",
}) {
  const normalizedValue =
    fieldValue === null || fieldValue === undefined || fieldValue === "" ? null : String(fieldValue);
  const selectedOption = data.find((option) => option.id === normalizedValue) ?? null;

  return (
    <AutoCompleteDropdown
      data={data}
      initValue={selectedOption}
      popupIcon={<KeyboardArrowDown sx={SETTLEMENT_STYLES.dropdownArrowIcon} />}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, optionValue) => String(option?.id) === String(optionValue?.id)}
      onValueChange={(_, value) => onChange(fieldName, value?.id ?? null)}
      ListboxProps={{ sx: SETTLEMENT_STYLES.listbox }}
      placeholder={placeholder}
      textFieldSx={PAYMENTS_MODAL_STYLES.textField}
      dropdownSx={PAYMENTS_MODAL_STYLES.dropdownPaper}
      disableClearable={true}
    />
  );
}
